module.exports = __webpack_public_path__ + "img/logo20250613.aeff8328.png";